// src/pages/Login/LoginPage.js
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const LoginPage = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = location.state?.from || '/roleplays';

  useEffect(() => {
    if (isLoading) return;

    // If already authenticated, go to gallery (or previous page)
    if (isAuthenticated) {
      navigate(returnTo, { replace: true });
      return;
    }

    loginWithRedirect({
      appState: { returnTo },
      authorizationParams: {
        type: 'admin',          // your custom param

      },
    });
  }, [isAuthenticated, isLoading, loginWithRedirect, navigate, location.state, returnTo]);

  return null;
};

export default LoginPage;
